import React from 'react';
import Header from '../../components/HeaderSection/Header';
import Footer from '../../components/FooterSection/Footer';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-page">
            <div className="main">
                <Header imageData={"/img/logo-white.png"} />
                
                {/* Privacy Policy Section */}
                <section 
                    className="section ptb_100" 
                    style={{ 
                        background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                        paddingTop: '150px'
                    }}
                >
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-10 col-lg-8">
                                {/* Section Heading */}
                                <div className="section-heading text-center">
                                    <h2 className="text-white">Gizlilik Politikası</h2>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-12">
                                <div className="privacy-content bg-white p-4 p-md-5 rounded shadow-lg">
                                    <div className="privacy-text">
                                        <p>
                                            Socia olarak web sitesi ve uygulama hizmetlerinden faydalanan kullanıcılarının ("Kullanıcı") bilgilerinin
                                            korunmasına ve gizliliğine önem verilmektedir.
                                        </p>
                                        
                                        <p>
                                            Bu Gizlilik Politikası Socia'nın topladığı bilgileri nasıl işlediği/işleyeceği ve kullandığı/kullanacağı,
                                            kullanıcıların sorumlulukları ve Socia'nın gizli bilgilerin korunmasına ilişkin kuralları hakkında
                                            kullanıcıları bilgilendirmeyi amaçlamaktadır.
                                        </p>
                                        
                                        <p>
                                            Ayrıca ve önemle belirtmek gerekir ki; Socia olarak kullanıcılara daha iyi hizmet vermek maksadı ile
                                            toplanılan ve talep edilen bilgiler 6698 sayılı kişisel verilerin korunması kanunu ve ilgili diğer tüm yasal
                                            mevzuatlar çerçevesinde işlenmektedir. veriler KVKK ve ilgili diğer yasal mevzuatlar çerçevesinde
                                            işlenme amacına uygun şekilde ve uygun süre ile saklanmaktadır. hangi kişisel verilerin işlendiği, hangi
                                            süre ve amaç ile saklandığı, toplanma yöntemi ve hukuki sebebine/gerekçesine, sahip olunan haklara
                                            ilişkin detaylı bilgiye Kişisel Verilerin Korunması Politikası-Aydınlatma Metni'nden erişilebilmektedir.
                                        </p>
                                        
                                        <p>
                                            Gizlilik Politikasına dair bilgi almak ve soru sormak için <a href="mailto:info@thesocia.co">info@thesocia.co</a> mail adresinden e-posta
                                            aracılığıyla erişim sağlayabilirsiniz.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">TOPLANAN BİLGİLER</h4>
                                        <p>
                                            Socia'ya ait web sitesi ve/ya uygulamadan yararlanılması durumunda kullanıcının üyelik kaydının
                                            yapılması, talep edilen ürün/hizmetlerden yararlanılması, ödemelerin gerçekleştirilmesi ve sair hususların
                                            gerçekleştirilebilmesi maksadıyla kullanıcıların bilgileri toplanılmaktadır.
                                        </p>
                                        
                                        <p>
                                            kullanıcılar, etkinlikleri incelemek, etkinliklere dair bilgi almak, bilet satın almak, öneri ve şikayetlerini
                                            Socia'ya iletmek veyahut başkaca sebeplerle bilgilerini Socia'ya sağlamaktadır. bu durumda,
                                            kullanıcıların ad-soyad, iletişim bilgileri, ödeme bilgileri, kaydedilen, incelenen ve takip edilen
                                            hesaplar/etkinlikler, talep, öneri ve şikâyet bilgileri gibi belirli bilgileri toplanmaktadır.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">BİLGİLERİN KULLANILMA AMAÇLARI</h4>
                                        <ul>
                                            <li>Kullanıcılara hizmet sunmak</li>
                                            <li>Kullanıcılar ile iletişime geçmek, kullanıcıların talep ve şikayetlerini sonuçlandırmak,</li>
                                            <li>Ödemelere ilişkin finans ve muhasebe süreçlerini yürütmek,</li>
                                            <li>Hizmetlerimizin tanıtımını sağlamak; reklam ve kampanya süreçlerini yürütmek,</li>
                                            <li>Kullanıcı geri bildirimlerine göre ürün ve hizmetlerimizi iyileştirmek/geliştirmek,</li>
                                            <li>Hizmetlerimizi kullanıcıların tercih, kullanım alışkanlıkları ve ilgi alanlarına göre özelleştirmek,</li>
                                            <li>Hizmetlerimizi sunduğumuz ortamlardaki sistemsel sorunları tanımlanmak ve gidermek; bilgi güvenliği süreçlerini yürütmek,</li>
                                            <li>Tanımlama teknolojileri/çerezler vasıtasıyla kullanıcı deneyimlerini ölçümlemek, hizmetlerimizi sunduğumuz ortamların performansını geliştirmek.</li>
                                        </ul>
                                        <p>
                                            Bu kısımda belirtilen amaçlar yalnızca toplanan bilgilerin genel kullanım amaçlarını ifade etmekte olup
                                            Socia'nın Kullanıcılar'ın kişisel verilerini işleme maksatları ile kişisel verilerin işlenmesi ve sair
                                            hususlarda detaylı bilgi almak için "kişisel verilerin korunması politikası-aydınlatma metni"
                                            incelenmelidir.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">BİLGİLERİN ÜÇÜNCÜ KİŞİLER İLE PAYLAŞIMI/AKTARIMI</h4>
                                        <p>
                                            Socia'ya Kullanıcı tarafından sağlanan bilgiler, yukarıda belirtilen amaçların gerçekleştirilebilmesi için
                                            üçüncü kişilere aktarılabilir (teknik destek hizmetinin sağlanmasında bu hizmeti sağlayan firmalar vb.).
                                            Bu kapsamda Kullanıcı'nın bilgileri, Socia'nın iş ortakları ve ürün/hizmet tedariki maksadıyla destek
                                            alınan 3. kişi konumunda olan firmalar ile paylaşılabilecektir. bunun yanı sıra, yasal yükümlülükleri
                                            yerine getirebilmek için Kullanıcı'nın bilgileri paylaşılması talep edildiğinde, bilgileriniz yetkili kişi,
                                            kurum ve kuruluşlar ile de paylaşılabilecektir.
                                        </p>
                                        
                                        <p>
                                            Kullanıcılar tarafından sağlanan bilgiler, Kullanıcılara sunulan sözleşme ve sair metinlerde yer alan
                                            amaçlar ile ilgili hizmetlerin sunulabilmesi için zaruri durumlar haricinde üçüncü kişilere
                                            aktarılmayacaktır.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">BİLGİLERİN SAKLANMASI VE KORUNMASI</h4>
                                        <p>
                                            Kullanıcı'nın bilgileri, bilgileri toplama amacının gerektirdiği süre kadar ilgili yasal mevzuatlar uyarınca
                                            saklanmaktadır. Mevzuatta Kullanıcı bilgilerinin saklanması için özel bir süre öngörülüyor ise, bu süreye
                                            uygunluk sağlanmaktadır. Socia, bilgilerin saklandığı/korunduğu sistemleri, sunucuları ve veri
                                            tabanlarını, veri güvenliği tehditlerine (siber saldırı vb.) karşı korumak için gerekli teknik ve idari
                                            tedbirleri almaktadır.
                                        </p>
                                        
                                        <p>
                                            Kullanıcı, Socia tarafından sunulan hizmetlerden faydalanabilmek maksadıyla kullanılan sistem erişim
                                            araçlarının (kullanıcı ismi, e-posta adresi, telefon numarası, şifre vb.) güvenliği, saklanması, üçüncü
                                            kişilerin bilgisinden uzak tutulması ile ilgili tüm sorumluluğun tamamen kendisine ait olduğunu kabul
                                            etmektedir.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">BİLGİLERİN DOĞRULUĞU VE GÜNCELLİĞİ</h4>
                                        <p>
                                            Kullanıcılar tarafından sağlanan bilgilerin doğruluğu ve güncelliği kullanıcıların sorumluluğundadır.
                                            Bilgilerin gerçeğe uygun olarak Socia'ya iletilmesi ve bilgilerde bir değişiklik olması durumunda
                                            güncellenmesi gerekmektedir.
                                        </p>
                                        
                                        <p>
                                            Socia ile paylaşılan bilgileri Kullanıcı istediği zaman <a href="mailto:info@thesocia.co">info@thesocia.co</a> mail adresine e-posta göndererek
                                            veyahut uygulamanın profil kısmından seçenekler bölümünde yer alan profili düzenle seçeneğinden
                                            güncelleme imkanına sahiptir.
                                        </p>
                                        
                                        <p>
                                            Socia'ya Kullanıcı tarafından bir başkası adına bilgi sağlandığında, bu bilgilerin doğru olduğunu, bilgileri
                                            Socia ile paylaşma hakkına sahip olduğunu/bu konuda yetkilendirildiğini taahhüt etmiş sayılmaktadır.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">ÜÇÜNCÜ TARAFLARA YAPILAN YÖNLENDİRMELER</h4>
                                        <p>
                                            Socia, Socia tarafından işletilmeyen üçüncü taraf bağlantılara yönlendirmeler yapabilir. İlgili
                                            bağlantılardan herhangi birini ziyaret sırasında, ziyaret edilen üçüncü tarafın gizlilik politikaları ve
                                            kullanım koşullarına tabi olunmaktadır. Socia söz konusu üçüncü tarafların politika ve uygulamalarından
                                            sorumlu değildir.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">MOBİL UYGULAMADA, WEB SİTESİNDE VE POLİTİKALARDA YAPILAN DEĞİŞİKLİKLER</h4>
                                        <p>
                                            Socia, sunulan hizmetleri, bilgileri, görselleri ve sair unsurları önceden bildirimde bulunmaksızın
                                            değiştirme, kullanımını askıya alma veya durdurma hakkını saklı tutmaktadır.
                                        </p>
                                        
                                        <p>
                                            Socia, Kişisel verilerin korunması Politikası üzerinde değişiklik ve güncelleme yapma hakkını saklı
                                            tutmaktadır. Politika'nın güncel versiyonunu takip etmek, kullanıcının sorumluluğundadır.
                                        </p>
                                        
                                        <h4 className="mt-4 mb-3">SORUMLULUK</h4>
                                        <p>
                                            Hizmetlerin elektronik ortamda sunulması sırasında oluşabilecek herhangi bir hata, kesinti, gecikme,
                                            virüs, hat ve/veya sistem arızası sonucunda ortaya çıkabilecek doğrudan veya dolaylı zarar ve
                                            masraflardan Socia sorumlu değildir.
                                        </p>
                                        
                                        <div className="text-center mt-5">
                                            <a href="/" className="btn btn-primary">Ana Sayfaya Dön</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
                <Footer />
            </div>
        </div>
    );
}

export default PrivacyPolicy;